import React, { useCallback, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { getClientQueries } from '../../../api';
import { columns } from './Consultas.columns';
import { jdsTableStyles } from '../../../components/jds/tableStyles';
import { JdsTableSkeleton } from '../../../components/jds/JdsSkeleton';
import { JdsPagination } from '../../../components/jds/JdsPagination';

export default function Consultas({ cliente_id }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);

  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 20,
  });

  const fetchQueries = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getClientQueries(cliente_id, {
        page: pagination.page,
        perPage: pagination.perPage,
      });

      setData(response.data.data);
      setTotalRows(response.data.pagination.total);
    } finally {
      setLoading(false);
    }
  }, [cliente_id, pagination]);

  useEffect(() => {
    fetchQueries();
  }, [fetchQueries]);

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  const handlePerPageChange = (newPerPage, page) => {
    setPagination({ page, perPage: newPerPage });
  };

  return (
    <>
      <h2 className="jds-title-md mb-6">Consultas do Jusfinder</h2>

      <div style={{ overflowX: 'auto', width: '100%' }}>
        <DataTable
          columns={columns}
          data={data}
          customStyles={jdsTableStyles}
          paginationComponent={JdsPagination}
          responsive={false}
          progressPending={loading}
          progressComponent={<JdsTableSkeleton />}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerPageChange}
        />
      </div>
    </>
  );
}
